import { render, staticRenderFns } from "./ActionRequiredUsersSelect.vue?vue&type=template&id=31c71a7f&"
import script from "./ActionRequiredUsersSelect.vue?vue&type=script&lang=ts&"
export * from "./ActionRequiredUsersSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports